<script lang="ts">
	import type { DocPage } from '$lib/data/docs-data';

	interface Props {
		prev?: DocPage;
		next?: DocPage;
	}

	let { prev, next }: Props = $props();
</script>

<nav class="flex justify-between mt-12 pt-8 border-t border-[#e5e5e5]">
	{#if prev}
		<a
			href="/docs/{prev.slug}"
			class="group flex items-center gap-3 text-[#5c5855] hover:text-[#ee6018] transition-colors"
		>
			<svg
				class="w-5 h-5 transition-transform group-hover:-translate-x-1"
				viewBox="0 0 20 20"
				fill="none"
			>
				<path
					d="M12.5 5L7.5 10L12.5 15"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<div class="text-left">
				<div class="text-[12px] font-mono text-[#878787] uppercase tracking-wide">Previous</div>
				<div class="font-body font-medium">{prev.title}</div>
			</div>
		</a>
	{:else}
		<div></div>
	{/if}

	{#if next}
		<a
			href="/docs/{next.slug}"
			class="group flex items-center gap-3 text-right text-[#5c5855] hover:text-[#ee6018] transition-colors"
		>
			<div>
				<div class="text-[12px] font-mono text-[#878787] uppercase tracking-wide">Next</div>
				<div class="font-body font-medium">{next.title}</div>
			</div>
			<svg
				class="w-5 h-5 transition-transform group-hover:translate-x-1"
				viewBox="0 0 20 20"
				fill="none"
			>
				<path
					d="M7.5 5L12.5 10L7.5 15"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</a>
	{/if}
</nav>
